<template>
  <div :style="styles" id="gkui-message-list">
    <transition-group :name="transitionName" @enter="handleEnter" @leave="handleLeave">
      <template v-for="item in messageList">
        <MessageItem 
          :key="item.name"
          :type="item.type"
          :duration="item.duration"
          :closable="item.closable"
          :name="item.name"
          :message="item.message"
          :onClose="item.onClose"
          :prefix="item.prefix"
          :customClose="item.customClose"
          :loadingColor="item.loadingColor"
          :loadingSize="item.loadingSize"
          :transitionName="transitionName"
          @close="close"
        />
      </template>
    </transition-group>
  </div>
</template>
<script>
import MessageItem from './Message'
import messageController from './MessageController'

export default {
  name: 'gku-message-box',
  components: {
    MessageItem
  },
  props: {
  },
  computed: {
  },
  data () {
    return {
      messageList: [],
      styles: {
        top: '24px'
      },
      transitionName: 'fade-up'
    }
  },
  created () {
    messageController.register(this)
  },
  mounted () {
  },
  methods: {
    add (message, props = {}) {
      this.styles = {...this.styles, ...props.styles}
      this.transitionName = props.transitionName
      this.$nextTick(() => {
        this.messageList.push(message)
      })
    },
    close (name) {
      this.messageList = this.messageList.filter(item => item.name !== name)
      messageController.remove(name)
    },
    clear () {
      this.messageList = []
    },
    handleEnter (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    handleLeave (el) {
      if (document.getElementsByClassName('gkui-message-content-wrap').length !== 1) {
        el.style.height = 0
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#gkui-message-list {
  position: fixed; top: 0; left: 0; z-index: 99000;
  width: 100%;
  pointer-events: none;
}
</style>

